import { config } from "../../helpers";
import { pushLocation } from "../utilities/customRoutes";
//import { BUDENTERPRISE_LOOKUP } from "./commercials/data";

const storageName = "apex"
let root = document.querySelector(`:root`);

// const data = BUDENTERPRISE_LOOKUP;

export const setApexStorage = val => localStorage.setItem(storageName, val)
export const setCountryStorage = val => localStorage.setItem("country", val)
export const resetStorage = () => {localStorage.setItem(storageName, ""); localStorage.setItem("country", ""); localStorage.setItem("enterprise", ""); enterpriseMenu(false, true)}

export const getApexStorage = (redirect = true) => { if (localStorage.getItem(storageName)) { return localStorage.getItem(storageName) } else if (redirect) { pushLocation("/commercials") } else{return ""} }
export const getCountryStorage = () => { if (localStorage.getItem("country")) { return localStorage.getItem("country") } else {return "AU"} }
export const isAU = () => (getCountryStorage() === "AU")

export const getEnterpriseLogo = () => null;// getApexStorage(false) ? `/images/budenterprise/budenterprise_${getApexStorage(false).split("-")[0]}.svg` : `/images/budenterprise/budenterprise.svg`

export const setEnterpriseLogo = () =>null; // root.style.setProperty('--bb-small-logo', `url("${getEnterpriseLogo()}")`);

export const resetLogo = () => null; //root.style.setProperty('--bb-small-logo', `url("/images/budenterprise/budenterprise.svg")`);

export const RenderEnterpriseLogo = () => null; //<div id="bb-buddy-logo-small" style={{ width: "185px" }} className="img-fluid bb-buddy-logo-small cursor-pointer mr-3" />

export const getModelName = () => getApexStorage(false)?.toLowerCase() || 'independent'

export const getModel = () => {
  let label = getApexStorage(false)?.toLowerCase();
    switch (label) {
        case "independent":
            return 1;
        case "unified-rewards":
            return 2;
        case "unified-discount":
            return 3;
        default:
            return 1;
    }
}

const parsePercentage = (percentStr) => {
    if (!percentStr) return NaN;
    if (typeof percentStr !== "string") return percentStr;
    return parseFloat(percentStr.replace('%', '').trim());
};


export const enterpriseMenu = (model, reset = false) => {
  let refundBlock = document.getElementById("1077")
  let savingsBlock = document.getElementById("1177")
  //let marginBlock = document.getElementById("1277")
  let feesBlock = document.getElementById("1188")
  let spendBlock = document.getElementById("1377")
  if (!reset) {
    if (model === 1) {
      feesBlock.style.display = "block";
    } else if (model === 2) {
      refundBlock.style.display = "block";
    } else {
      savingsBlock.style.display = "block";
      //marginBlock?.style?.display = "block";
    }
    spendBlock.style.display = "block"
  }
  else {
    if(feesBlock) feesBlock.style.display = "none"; 
    if(refundBlock) refundBlock.style.display = "none"; 
    if(savingsBlock) savingsBlock.style.display = "none";
    //if(marginBlock) marginBlock.style.display = "none"; 
    if(spendBlock) spendBlock.style.display = "none";
  }
}

export function roundDownToNearestHalf(num) {
  //console.log(num)
  return roundDownToNearestTenth(num)
  //console.log("not", num)
  //return Math.floor(num * 2) / 2;
}

function roundDownToNearestTenth(num) {
  // Multiply by 10, floor, then divide by 10
  const rounded = Math.round(num * 10) / 10;
  // Convert to a string with exactly two decimal places
  return rounded;
}

export const getAdjustedCPM = (inputModel, monthlySpendBand, premiumCPM, advancedCPM, liteCPM, skinCPM, country = "AU", data) => {
  const premiumPerc = getSinglePercentage(inputModel, monthlySpendBand, premiumCPM, country, data);
  const advancedPerc = getSinglePercentage(inputModel, monthlySpendBand, advancedCPM, country,data);
  const litePerc = getSinglePercentage(inputModel, monthlySpendBand, liteCPM, country, data);
  const skinPerc = getSinglePercentage(inputModel, monthlySpendBand, skinCPM, country,data);

    const adjusted_cpm = {
      prem: roundDownToNearestHalf((((100 - premiumPerc) * premiumCPM)/100)).toFixed(2),
      adv: roundDownToNearestHalf((((100 - advancedPerc) * advancedCPM)/100)).toFixed(2),
      lite: roundDownToNearestHalf((((100 - litePerc) * liteCPM)/100)).toFixed(2),
      skin: roundDownToNearestHalf((((100 - skinPerc) * skinCPM)/100)).toFixed(2),
    }
    return adjusted_cpm;
}
export const getPercentagePaid = (inputModel, monthlySpendBand, premiumCPM, advancedCPM, liteCPM, skinCPM, country = "AU", data) => {
    
    console.log(inputModel, monthlySpendBand, liteCPM, premiumCPM, advancedCPM, skinCPM, country)
    // Helper function to parse percentage string to number
    if(country !== "AU"){
      liteCPM = 0
      skinCPM = 0
    }
    // Filter items for premium and advanced CPM matches
    const filterByCPM = (cpm) =>
        data.filter(
            (item) =>
                item.model === inputModel &&
                item.monthly_spend_band === monthlySpendBand &&
                item.combined_cpm === cpm &&
                item.country === country
        );

    const premiumMatches = filterByCPM(premiumCPM);
    const advancedMatches = filterByCPM(advancedCPM);
    const liteMatches = filterByCPM(liteCPM);
    const skinMatches = filterByCPM(skinCPM);

    // Extract and parse percentage values from matched items
    const percentages = [
        ...premiumMatches.map((item) => parsePercentage(item.percentage)),
        ...advancedMatches.map((item) => parsePercentage(item.percentage)),
        ...liteMatches.map((item) => parsePercentage(item.percentage)),
        //...skinMatches.map((item) => parsePercentage(item.percentage))
        ...(!inputModel.toLowerCase().includes('unified') ? skinMatches.map((item) => parsePercentage(item.percentage)) : [])

    ].filter((p) => !isNaN(p)); // filter out any NaN values

    //console.log(percentages)
    // If no matching percentages found, return null or a default value
    if (percentages.length === 0) {
        return null;
    }    

    // Determine result based on model type
    if (inputModel.toLowerCase().includes('unified')) {
        const minValue = Math.min(...percentages);
        return `${minValue.toFixed(2)}%`;
    } else {
        const maxValue = Math.max(...percentages);
        return `${maxValue.toFixed(2)}%`;
    }
}

function getSinglePercentage(model, monthlySpendBand, cpm, country = "AU", data) {
    const matches = data.filter(item =>
      item.model === model &&
      item.monthly_spend_band === monthlySpendBand &&
      item.combined_cpm === cpm &&
      item.country === country
    );
    
    const percentages = matches
      .map(item => parsePercentage(item.percentage))
      .filter(p => !isNaN(p));
    
    if (percentages.length === 0) return 0;
    // Use min for "Unified" model, max otherwise
    if (model.toLowerCase().includes('unified')) {
      return Math.min(...percentages);
    } else {
      return Math.max(...percentages);
    }
  }

export const calculateSaasFees = (model, premiumMonthlySpend, advancedMonthlySpend, premiumCPM, advancedCPM, 
                                  liteMonthlySpend, skinMonthlySpend, liteCPM, skinCPM, country = "AU", data) => {

    if(country !== "AU"){
      liteCPM = 0
      skinCPM = 0
      liteMonthlySpend = 0
      skinMonthlySpend = 0
    }                                    
    // Calculate total spend
    const totalSpend = premiumMonthlySpend + advancedMonthlySpend + liteMonthlySpend + skinMonthlySpend;
  
    // Find all records matching the model and where totalSpend fits the spend band
    const possibleBands = data.filter(item =>
      item.model === model &&
      item.min_spend_band <= totalSpend &&
      item.max_spend_band >= totalSpend &&
      item.country === country
    );
  
    // Extract unique monthly spend bands from the filtered records
    const bands = [...new Set(possibleBands.map(item => item.monthly_spend_band))];
    if (bands.length === 0) {
      console.error("No matching monthly spend band found.");
      return null;
    }
    // Assume the first matching band is correct
    const monthlySpendBand = bands[0];
    // Retrieve percentages for premium and advanced using the same band
    const premiumPerc = getSinglePercentage(model, monthlySpendBand, premiumCPM, country, data);
    const advancedPerc = getSinglePercentage(model, monthlySpendBand, advancedCPM, country, data);
    const litePerc = getSinglePercentage(model, monthlySpendBand, liteCPM, country, data);
    const skinPerc = getSinglePercentage(model, monthlySpendBand, skinCPM, country, data);
  
    if (premiumPerc === null || advancedPerc === null) {
      console.error("Percentages not found for provided CPMS and model.");
      return null;
    }
  
    // Calculate SaaS fees
    const premiumSaasFee = (premiumPerc/100) * premiumMonthlySpend;
    const advancedSaasFee = (advancedPerc/100) * advancedMonthlySpend;
    const liteSaasFee = (litePerc/100) * liteMonthlySpend;
    const skinSaasFee = (skinPerc/100) * skinMonthlySpend;


    const totalMonthlySpend = premiumMonthlySpend + advancedMonthlySpend + liteMonthlySpend + skinMonthlySpend;
    const totalSaasFee = premiumSaasFee + advancedSaasFee + liteSaasFee + skinSaasFee;
  
    // Calculate remaining SaaS fee and percentage paid
    const saasFee = model.toLowerCase().includes('unified') ? totalSaasFee : (totalMonthlySpend - totalSaasFee);
    const bigadsSaasFee = model.toLowerCase().includes('unified') ? (totalMonthlySpend - totalSaasFee) : totalSaasFee
    const percentagePaid = (saasFee / totalMonthlySpend) * 100;
    console.log(premiumSaasFee,
        advancedSaasFee,
        liteSaasFee,
        skinSaasFee,
        saasFee,
        percentagePaid,
        monthlySpendBand,
        totalSaasFee, "totalSaasFeePercentage", 100 - Number(percentagePaid).toFixed(2))

    return {
      premiumSaasFee,
      advancedSaasFee,
      liteSaasFee,
      skinSaasFee,
      saasFee,
      percentagePaid: Number(percentagePaid).toFixed(2),
      monthlySpendBand,
      totalSaasFee: bigadsSaasFee,  
      totalSaasFeePercentage: (100 - Number(percentagePaid).toFixed(2)).toFixed(2),
      annual_fee: 12 * bigadsSaasFee,
      annual_earnings: 12 * saasFee,
      total_predicted_spend: totalSpend
    };
  }
  

  export const calculateDiscounts = (premiumMonthlySpend, advancedMonthlySpend, liteMonthlySpend, skinMonthlySpend, premiumCPM, advancedCPM, liteCPM, skinCPM, country = "AU", data) => {
    // Calculate total spend
    const totalSpend = premiumMonthlySpend + advancedMonthlySpend + liteMonthlySpend + skinMonthlySpend;
    let model = "unified-discount"
    // Find all records matching the model and where totalSpend fits the spend band
    const possibleBands = data.filter(item =>
      item.model === model &&
      item.min_spend_band <= totalSpend &&
      item.max_spend_band >= totalSpend &&
      item.country === country
    );

    const imp_purchased = {
      prem: Math.round((premiumMonthlySpend / premiumCPM) * 1000),
      adv: Math.round((advancedMonthlySpend / advancedCPM) * 1000),
      lite: Math.round((liteMonthlySpend / liteCPM) * 1000),
      skin: Math.round((skinMonthlySpend / skinCPM) * 1000),
    }
  
    // Extract unique monthly spend bands from the filtered records
    const bands = [...new Set(possibleBands.map(item => item.monthly_spend_band))];
    if (bands.length === 0) {
      console.error("No matching monthly spend band found.");
      return {
        imp_purchased,
        vol_discount: {prem: 0, adv: 0, lite: 0, skin: 0},
        adjusted_cpm: {prem: premiumCPM, adv: advancedCPM, lite: liteCPM, skin: skinCPM},
        imp_increase: {prem: 0, adv: 0, lite: 0, skin: 0},
        adjusted_imp: {prem: Math.round((premiumMonthlySpend / premiumCPM) * 1000 ),
                       adv: Math.round((advancedMonthlySpend / advancedCPM) * 1000 ),
                       lite: Math.round((liteMonthlySpend / liteCPM) * 1000),
                       skin: Math.round((skinMonthlySpend / skinCPM) * 1000),
                      
                      },
        total_predicted_spend: totalSpend
      };
    }
    // Assume the first matching band is correct
    const monthlySpendBand = bands[0];
    // Retrieve percentages for premium and advanced using the same band
    const premiumPerc = getSinglePercentage(model, monthlySpendBand, premiumCPM, country, data);
    const advancedPerc = getSinglePercentage(model, monthlySpendBand, advancedCPM, country, data);
    const litePerc = getSinglePercentage(model, monthlySpendBand, liteCPM, country, data);
    const skinPerc = getSinglePercentage(model, monthlySpendBand, skinCPM, country, data);
  
    if (premiumPerc === null || advancedPerc === null) {
      console.error("Percentages not found for provided CPMS and model.");
      return null;
    }
  
    
    const vol_discount = {
      prem: premiumMonthlySpend > 0 ? premiumPerc.toFixed(2) : 0,
      adv: advancedMonthlySpend > 0 ? advancedPerc.toFixed(2) : 0,
      lite: liteMonthlySpend > 0 ? litePerc.toFixed(2) : 0,
      skin: skinMonthlySpend > 0 ? skinPerc.toFixed(2) : 0,
    }
    const adjusted_cpm = {
      prem: premiumMonthlySpend > 0 ? roundDownToNearestHalf((((100 - premiumPerc) * premiumCPM)/100)).toFixed(2) : 0,
      adv: advancedMonthlySpend > 0 ? roundDownToNearestHalf((((100 - advancedPerc) * advancedCPM)/100)).toFixed(2): 0,
      lite: liteMonthlySpend > 0 ? roundDownToNearestHalf((((100 - litePerc) * liteCPM)/100)).toFixed(2): 0,
      skin: skinMonthlySpend > 0 ? roundDownToNearestHalf((((100 - skinPerc) * skinCPM)/100)).toFixed(2): 0,
    }

    const imp_increase = {
      prem: Math.round((premiumMonthlySpend * (premiumCPM - adjusted_cpm.prem)/ (premiumCPM * adjusted_cpm.prem)) * 1000),
      adv: Math.round((advancedMonthlySpend * (advancedCPM - adjusted_cpm.adv)/ (advancedCPM * adjusted_cpm.adv)) * 1000),      
      lite: Math.round((liteMonthlySpend * (liteCPM - adjusted_cpm.lite)/ (liteCPM * adjusted_cpm.lite)) * 1000),      
      skin: Math.round((skinMonthlySpend * (skinCPM - adjusted_cpm.skin)/ (skinCPM * adjusted_cpm.skin)) * 1000),      
    }

    const adjusted_imp = {
      prem: Math.round((premiumMonthlySpend / adjusted_cpm.prem) * 1000 ),
      adv: Math.round((advancedMonthlySpend / adjusted_cpm.adv) * 1000 ),
      lite: Math.round((liteMonthlySpend / adjusted_cpm.lite) * 1000 ),
      skin: Math.round((skinMonthlySpend / adjusted_cpm.skin) * 1000 ),
    }
        
    return {
      imp_purchased,
      vol_discount,
      adjusted_cpm,
      imp_increase,
      adjusted_imp,
      total_predicted_spend: totalSpend
    };
  }
  

  export const calculateRefundRate = (premiumMonthlySpend, advancedMonthlySpend, liteMonthlySpend, skinMonthlySpend,premiumCPM, advancedCPM,liteCPM, skinCPM, country = "AU", data) => {
    // Calculate total spend
    const totalSpend = premiumMonthlySpend + advancedMonthlySpend + liteMonthlySpend + skinMonthlySpend;
    let model = "unified-rewards"
    // Find all records matching the model and where totalSpend fits the spend band
    const possibleBands = data.filter(item =>
      item.model === model &&
      item.min_spend_band <= totalSpend &&
      item.max_spend_band >= totalSpend &&
      item.country === country
    );
  
    // Extract unique monthly spend bands from the filtered records
    const bands = [...new Set(possibleBands.map(item => item.monthly_spend_band))];
    if (bands.length === 0) {
      console.error("No matching monthly spend band found.");
      return {
        adjusted_cpm: {prem: premiumCPM, adv: advancedCPM, lite: liteCPM, skin: skinCPM},
        total_predicted_spend: totalSpend
      };
    }
    // Assume the first matching band is correct
    const monthlySpendBand = bands[0];
    // Retrieve percentages for premium and advanced using the same band
    const premiumPerc = getSinglePercentage(model, monthlySpendBand, premiumCPM, country, data);
    const advancedPerc = getSinglePercentage(model, monthlySpendBand, advancedCPM, country, data);
    const litePerc = getSinglePercentage(model, monthlySpendBand, liteCPM, country, data);
    const skinPerc = getSinglePercentage(model, monthlySpendBand, skinCPM, country, data);
  
    if (premiumPerc === null || advancedPerc === null) {
      console.error("Percentages not found for provided CPMS and model.");
      return null;
    }
      
    const adjusted_cpm = {
      prem: premiumMonthlySpend > 0 ? roundDownToNearestHalf((((100 - premiumPerc) * premiumCPM)/100)).toFixed(2) : 0,
      adv: advancedMonthlySpend > 0 ? roundDownToNearestHalf((((100 - advancedPerc) * advancedCPM)/100)).toFixed(2): 0,
      lite: liteMonthlySpend > 0 ? roundDownToNearestHalf((((100 - litePerc) * liteCPM)/100)).toFixed(2): 0,
      skin: skinMonthlySpend > 0 ? roundDownToNearestHalf((((100 - skinPerc) * skinCPM)/100)).toFixed(2): 0,
    }
        
    return {     
      adjusted_cpm,     
      total_predicted_spend: totalSpend
    };
  }
  
export const formatText = config.commbank ? ["In-app", "Homepage", "Native", "In Branch"] : ["Display", "Rich Media", "Instream Video", "DOOH"]
export const formatPricing = config.commbank ? [7, 17, 21, 28] : [7, 17, 21, 29]